import React from "react";
import { Wrapper } from "../styles";

const ServiceCard = ({ data }) => {
  return (
    <Wrapper
      width="25%"
      height="16rem"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <img src={data.image} alt={data.title} />
      <h2
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          lineHeight: "20px",
          color: "rgba(40, 35, 35, 0.7)",
        }}
      >
        {data.title}
      </h2>
      <p>{data.description}</p>
    </Wrapper>
  );
};

export default ServiceCard;
